import { z } from 'zod';
/**
 * Talabnomaning HOLATLARI — butun oqimning yuragi.
 *
 * Ro'yxat shartnomada turadi (`movement.ts` dagi qoidaning davomi): holatni
 * backend yozadi va tekshiradi, frontend esa yorliq ko'rsatadi va tugmalarni
 * shu holatga qarab chizadi. Ro'yxat ikki marta yozilsa, ular albatta bir kun
 * ajralib ketadi (`apps/web` `apps/api` dan import qila olmaydi).
 *
 * Tartib ATAYLAB oqim tartibida: `DRAFT` dan `CLOSED` gacha asosiy yo'l, oxirida
 * ikki tugash holati (`REJECTED`, `CANCELLED`). Ro'yxatning O'ZI o'tishlarni
 * belgilamaydi — kimdan kimga o'tish mumkinligini FAQAT state machine biladi
 * (`apps/api/src/contexts/requisition/domain/transitions.ts`).
 */
export const REQUISITION_STATUSES = [
    'DRAFT',
    'SUBMITTED',
    'ORG_APPROVED',
    'WAREHOUSE_ACCEPTED',
    'ACCOUNTING_PENDING',
    'ACCOUNTING_APPROVED',
    'READY_FOR_PICKUP',
    'HANDED_OVER',
    'RECEIPT_CONFIRMED',
    'CLOSED',
    'REJECTED',
    'CANCELLED',
];
export const requisitionStatusSchema = z.enum(REQUISITION_STATUSES);
export const isRequisitionStatus = (value) => REQUISITION_STATUSES.includes(value);
const REQUISITION_STATUS_LABELS = {
    DRAFT: 'Qoralama',
    SUBMITTED: 'Yuborilgan',
    ORG_APPROVED: 'Korxona tasdiqladi',
    WAREHOUSE_ACCEPTED: 'Sklad qabul qildi',
    ACCOUNTING_PENDING: "So'rovnoma ochilgan",
    ACCOUNTING_APPROVED: 'Buxgalteriya tasdiqladi',
    READY_FOR_PICKUP: 'Olib ketishga tayyor',
    HANDED_OVER: 'Berildi',
    RECEIPT_CONFIRMED: 'Qabul tasdiqlandi',
    CLOSED: 'Yopilgan',
    REJECTED: 'Rad etilgan',
    CANCELLED: 'Bekor qilingan',
};
/**
 * Holatning o'zbekcha yorliqi.
 *
 * Nomi `statusLabel` emas: shartnoma paketi bitta barrel (`index.ts`) orqali
 * chiqadi va u yerda `statusLabel` degan umumiy nom boshqa kontekst bilan
 * to'qnashishi muqarrar (`unitLabel`, `movementTypeLabel` bilan bir uslub).
 */
export const requisitionStatusLabel = (status) => REQUISITION_STATUS_LABELS[status];
/** Yakuniy holatlar — bulardan keyin talabnoma o'zgarmaydi. */
export const TERMINAL_REQUISITION_STATUSES = ['CLOSED', 'CANCELLED'];
export const isTerminalRequisitionStatus = (status) => TERMINAL_REQUISITION_STATUSES.includes(status);
//# sourceMappingURL=status.js.map